var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLongCompass(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 245,
    height: 24,
    viewBox: "0 0 245 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22.5 12H102.5",
    stroke: "#131C7A",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeDasharray: "4 4"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M112.5 12C112.5 6.48 116.97 2 122.5 2C128.02 2 132.5 6.48 132.5 12C132.5 17.53 128.02 22 122.5 22C116.97 22 112.5 17.53 112.5 12ZM124.73 13.83L126.35 8.71C126.46 8.36 126.14 8.03 125.79 8.14L120.67 9.74C120.46 9.81 120.29 9.97 120.23 10.18L118.63 15.31C118.52 15.65 118.85 15.98 119.19 15.87L124.29 14.27C124.5 14.21 124.67 14.04 124.73 13.83Z",
    fill: "#131C7A"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M142.5 12H222.5",
    stroke: "#131C7A",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeDasharray: "4 4"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLongCompass);
export default __webpack_public_path__ + "static/media/long-compass.d4dc108db2964594e93797fcab68dcc8.svg";
export { ForwardRef as ReactComponent };